import React from 'react';
import { PRICE, PRICE_BEFORE } from '../data/gymklar';
// Static info bar. No countdown or timers.
export function InfoBar() {
  return <div className="w-full border-b border-white/10 bg-slate-900 text-stone-50" data-id="element-180" data-mp="2fiefambz2hx0">
      <p className="mx-auto max-w-6xl px-4 py-2.5 text-center text-xs font-medium sm:text-sm" data-id="element-181" data-mp="2jiere0blmh0w">
        Introduktionspris {PRICE} <s className="opacity-60" data-id="element-182" data-mp="2ok43ljak50qk">{PRICE_BEFORE}</s> · Engangsbetaling · 7 dages garanti
      </p>
    </div>;
}